import React from 'react'

export function SkeletonHeading({ level }: { level: 1 | 2 | 3 | 4 | 5 | 6 }) {
  return <div className={`c-skeleton c-skeleton--heading-${level}`} />
}
